import { ref, computed } from 'vue';
import { AliOssUpload } from '@/utils/ali-oss';
import { Message } from 'irm-ui';
import i18n from '@/locales';

export const useImageUpload = (options = {}) => {
	const { limit = 10, accept = ['png', 'jpg', 'jpeg'], onUpload, onStart, onFinish } = options;

	const uploadExt = ref(accept);
	const formatUploadExt = computed(() => uploadExt.value.map(type => `.${type}`).toString());

	const beforeImageUpload = file => {
		const isImage = uploadExt.value.includes(file.type.slice(6));
		const isLt10M = file.size / 1024 / 1024 < limit;

		if (!isImage) {
			Message.error(i18n.t('enterprise.field.upload-image-format-error'));
		}
		if (!isLt10M) {
			Message.error(i18n.t('enterprise.field.upload-image-size-limit', { limit }));
		}
		return isImage && isLt10M;
	};
	const uploadFile = async ({ file }) => {
		const ext = file.name.split('.').at(-1);
		if (!uploadExt.value.includes(ext)) {
			Message.warning(i18n.t('enterprise.field.upload-file-format-unsupported'));
			return false;
		}

		startUpload();
		const res = await AliOssUpload({
			file: file,
			fileName: file.name
		});
		onUpload && onUpload(res);
		finishUpload();
	};

	const uploading = ref(false);
	const setUploading = value => {
		uploading.value = value;
	};

	const startUpload = () => {
		onStart && onStart();
		setUploading(true);
	};
	const finishUpload = () => {
		onFinish && onFinish();
		setUploading(false);
	};

	return {
		beforeImageUpload,
		uploadFile,
		formatUploadExt,
		uploading
	};
};
